import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { convertNodes, Node, NodeSchema } from "../types/node"
import { STALE_TIME } from "../types/staleTime"
import { apiDelete, apiGet, apiPost } from "./query"

const ENDPOINT = "node"

export const useNodeGetAll = () => {
  return useQuery({
    queryKey: ["node"],
    queryFn: async () => (await apiGet(ENDPOINT, convertNodes)).data,
    staleTime: STALE_TIME.MIN_30,
    throwOnError: true,
  })
}

export const useNodeUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (node: NodeSchema) => apiPost(`${ENDPOINT}/${node.id}`, node),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["node"] }),
    throwOnError: true,
  })
}

export const useNodeDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: Pick<Node, "id">) => apiDelete(`${ENDPOINT}/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["node"] }),
    throwOnError: true,
  })
}
